function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#121212",
  d: "M79.167 26.708l-5.875-5.875L50 44.125 26.708 20.833l-5.875 5.875L44.125 50 20.833 73.292l5.875 5.875L50 55.875l23.292 23.292 5.875-5.875L55.875 50l23.292-23.292z"
});

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03OS4xNjY3IDI2LjcwODRMNzMuMjkxNyAyMC44MzM0TDUwIDQ0LjEyNUwyNi43MDg0IDIwLjgzMzRMMjAuODMzNCAyNi43MDg0TDQ0LjEyNSA1MEwyMC44MzM0IDczLjI5MTdMMjYuNzA4NCA3OS4xNjY3TDUwIDU1Ljg3NUw3My4yOTE3IDc5LjE2NjdMNzkuMTY2NyA3My4yOTE3TDU1Ljg3NSA1MEw3OS4xNjY3IDI2LjcwODRaIiBmaWxsPSIjMTIxMjEyIi8+Cjwvc3ZnPgo=";
export { SvgClose as ReactComponent };